<template>
    <div class="h100">
        <div class="flex h100">
            <div class="h100 flex-width mr20 flex-column">
                <div class="flex items-center">
                    <div class="flex-width flex items-center">
                        <div class="fs12 bold">{{project.name}}</div>
                        <div class="fs12 ml10 cursor-pointer" style="color: #2979ff;" @click="back">
                            返回
                        </div>
                    </div>
                    <el-button icon="el-icon-circle-plus-outline" size="mini" type="text" @click="addContract">添加合同</el-button>
                </div>
                <div class="flex-height mt5">
                    <el-table :data="showContracts" style="width: 100%" height="100%" size="mini">
                        <el-table-column prop="id" label="ID" width="100"></el-table-column>
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="create_name" label="发起人"></el-table-column>
                        <el-table-column prop="create_time" label="创建时间"></el-table-column>
                        <el-table-column label="详情" width="100" fixed="right">
                            <template slot-scope="scope">
                                <div>
                                    <el-button type="text" size="mini" @click="contractDetails(scope.row)">查看详情</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h100 flex-column" style="width: 300px; border-left: 1px solid rgba(0,0,0,0.05);">
                <div class="pl20 mt20 bold flex items-center">
                    <div class="fs14">合同模版</div>
                    <div class="ml5">
                        <i class="el-icon-circle-plus-outline" @click="dialogVisible=true"></i>
                    </div>
                </div>
                <div class="flex-height scroll">
                    <ul class="fs14 user_group">
                        <li @click="chooseTemplate(group)" :class="group.id == selectTemplate ? 'active' : ''" v-for="group in templates" :key="group.id">{{group.name}}</li>
                    </ul>
                </div>
            </div>
        </div>

        <el-dialog
            title="编辑合同模版"
            :visible.sync="dialogVisible"
            width="50%">
            <div>
                <div>
                    <div class="bold">模版名称</div>
                    <el-input size="medium" class="mt5" v-model="form.name" placeholder="请输入模版名称"></el-input>
                </div>
                <div class="mt15">
                    <div class="bold">模版流程</div>
                    <div class="mt5">
                        <div style="overflow: hidden;">
                            <div @click="deselect(group)" class="mr10 mb5 select-flow-item" v-for="group in flows" :key="group.id" style="float: left;">
                                <div class="item">
                                    {{group.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt15">
                    <div class="bold">点击设置模版流程</div>
                    <div class="mt5">
                        <div style="overflow: hidden;">
                            <div @click="selectFlow(group)" class="flow-item mr10 mb5" v-for="group in groups" :key="group.id" style="float: left;">
                                {{group.name}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt15">
                    <div class="bold">抄送</div>
                    <div class="mt5">
                        <el-select class="w100" v-model="form.chaosong" multiple placeholder="请选择" size="medium">
                            <el-option
                            v-for="item in groups"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveTemplate">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="新建合同"
            :visible.sync="dialogContractVisible"
            width="30%">
            <div>
                <div>
                    <div class="bold">名称</div>
                    <el-input size="medium" class="mt5" v-model="contractForm.name" placeholder="请输入名称"></el-input>
                </div>
                <div class="mt15">
                    <div class="bold">合同模版</div>
                    <el-select class="mt5 w100" v-model="contractForm.template_id" placeholder="请选择模版" @change="onChangeTemplate">
                        <el-option
                            v-for="item in showTemplates"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogContractVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveContract">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            project: {},
            form: {
                name: "",
                chaosong: []
            },
            flows: [],
            groups: [],
            templates: [],
            selectTemplate: -1,
            contracts: [],

            dialogContractVisible: false,
            contractForm: {
                name: ""
            }
        }
    },
    computed: {
        showContracts() {
            if (this.selectTemplate == -1) {
                return this.contracts;
            } else {
                return this.contracts.filter((it) => {
                    return it.template_id == this.selectTemplate;
                })
            }
        },
        showTemplates() {
            return this.templates.filter((it) => {
                return it.id != -1;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getProject();
        this.getUserGroup();
        this.getContractTemplates();
        this.getContracts();
    },
    methods: {
        async getProject() {
            let rs = await this.$api.project(this.id);
            if (rs.err == 0) {
                // console.log(rs.data);
                this.project = rs.data;
            }
        },
        async getContractTemplates() {
            let rs = await this.$api.getContractTemplates();
            if (rs.err == 0) {
                this.templates = rs.data;
                this.templates.unshift({
                    id: -1, name: "全部"
                })
            }
        },
        async getContracts() {
            let rs = await this.$api.getContracts(this.id);
            if (rs.err == 0) {
                this.contracts = rs.data;
            }
        },
        async getUserGroup() {
            this.groupMap = {};
            let rs = await this.$api.getUserGroup();
            if (rs.err == 0) {
                this.groups = rs.data;
                for (let item of rs.data) {
                    this.groupMap[item.id] = item;
                }
            }
        },
        selectFlow(group) {
            if (this.flows.indexOf(group) == -1) {
                this.flows.push(group);
            }
        },
        deselect(group) {
            let i = this.flows.indexOf(group);
            if (i != -1) {
                this.flows.splice(i, 1);
            }
        },
        async saveTemplate() {
            this.form.flows = this.flows.map((it) => {
                return it.id;
            })
            if (this.form.flows.length == 0 || this.form.name == "") {
                this.$message("信息填写不完整");
                return;
            }
            let rs = await this.$api.createContractTemplate(this.form);
            if (rs.err == 0) {
                this.$message({
                    message: '创建成功',
                    type: 'success'
                });
                this.dialogVisible = false;
                this.getContractTemplates();
            }
        },
        chooseTemplate(template) {
            this.selectTemplate = template.id;
        },
        onChangeTemplate(template_id) {
            let template = this.templates.find((it) => {
                return it.id == template_id;
            })
            if (this.contractForm.name == "") {
                this.contractForm.name = template.name;
            }
        },
        addContract() {
            let template = this.templates.find((it) => {
                return it.id == this.selectTemplate;
            })
            if (template.id != -1) {
                if (this.contractForm.name == "") {
                    this.contractForm.name = template.name;
                }
                this.contractForm.template_id = template.id;
            }
            this.dialogContractVisible = true;
        },
        async saveContract() {
            let rs = await this.$api.saveContract(this.contractForm.name, this.contractForm.template_id, this.id);
            if (rs.err == 0) {
                this.$message({
                    message: '创建成功',
                    type: 'success'
                });
                this.dialogContractVisible = false;
                this.getContracts();
            } else {
                this.$message("创建失败");
            }
        },
        contractDetails(item) {
            this.$router.push(`/contract_detail/${this.id}/${item.id}`);
        },
        back() {
            this.$router.back();
        }
    }
}
</script>

<style lang="less" scoped>
.flow-item {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.1);
    padding: 5px 5px 5px 5px;
    font-size: 12px;
}
.select-flow-item {
    cursor: pointer;
    position: relative;
    .item {
        border-bottom: 1px solid rgba(0,0,0,0.1);
        padding: 5px 5px 5px 5px;
        font-size: 12px;
    }
}
.select-flow-item:not(:last-child):after {
    content: "";
    position: absolute;
    right: -10px;
    top: 13px;
    height: 2px;
    width: 10px;
    background: #67C23A;
}
.user_group {
    list-style-type: none;
    margin: 0;
    padding-left: 20px;
    padding-top: 10px;

    li {
        height: 30px;
        border: 1px solid rgba(0,0,0,0.05);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        cursor: pointer;

        &.active {
            background: #67C23A;
            color: white;
        }
    }
}
</style>